module.exports = __webpack_public_path__ + "img/eye(white).f61b0c7c.svg";